export default __webpack_public_path__ + "static/pantana-na-takuathung-peppercloud-customer-4c46485a8541a868bfb6afbab73ec791.png";